import { zetApi } from '@zet/network'

type getLoyaltyPayoutProps = {
  partnerId?: number | string
  partnerCategoryId?: string | number
  isHighestLoyaltyPayout?: boolean
  isAllLevelPayout?: boolean
  isUserCurrentTierPayout?: boolean
  isNewRecommendationFlow?: boolean
}

export const getLoyaltyPayout = async ({
  partnerId,
  partnerCategoryId,
  isHighestLoyaltyPayout,
  isAllLevelPayout,
  isUserCurrentTierPayout,
  isNewRecommendationFlow,
}: getLoyaltyPayoutProps) => {
  const { data } = await zetApi.get(
    isNewRecommendationFlow
      ? `${
          partnerCategoryId
            ? `/loyalty/payout/partner-category-id/${partnerCategoryId}`
            : `/loyalty/payout/partner-id/${Number(partnerId)}`
        }`
      : `${
          partnerCategoryId
            ? `/loyalty/payout/partner-id/${Number(
                partnerId
              )}/category-code/${partnerCategoryId}`
            : `/loyalty/payout/partner-id/${Number(partnerId)}`
        }`,
    {
      params: {
        ...(isHighestLoyaltyPayout && {
          highestLoyaltyPayout: isHighestLoyaltyPayout,
        }),
        ...(isAllLevelPayout && {
          allLevelPayout: isAllLevelPayout,
        }),
        ...(isUserCurrentTierPayout && {
          userCurrentTierPayout: isUserCurrentTierPayout,
        }),
      },
    }
  )
  return data?.data
}
